import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { IconCheckFill, IconLocked, Text, tokens } from '@fhs/ui';
import { Nullable } from '@rbi-ctg/frontend';

interface Props {
  enabled?: Nullable<boolean>;
  label: string;
  style?: StyleProp<ViewStyle>;
}

export function PointsBadge({ enabled, label, style }: Props) {
  const a11yLabel = enabled
    ? `${label} points, available to redeem`
    : `${label} points required, locked`;

  return (
    <View
      accessibilityLabel={a11yLabel}
      accessibilityRole="text"
      accessible
      style={[styles.container, style]}
    >
      <View
        accessible={false}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
      >
        {enabled ? <IconCheckFill color={tokens.colors.$success} /> : <IconLocked />}
      </View>
      <Text.Ui accessible={false} size="sm" weight="semibold" style={styles.label}>
        {label}
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    backgroundColor: tokens.colors.$houseLight,
    flexDirection: 'row',
    alignSelf: 'flex-start',
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  label: {
    marginLeft: 4,
  },
});
